module.exports = __webpack_public_path__ + "img/status_validate_security_measures_on_systems.b95c29b1.gif";